"use client";
import useProfileStore from "@/stores/profile";
import { logout } from "../services/auth.services";
import { ERROR_MESSAGES_LOGOUT } from "@/constants/messages";
import { useToast } from "@/components/ui/toastercustom";
import { onRemoveCookie } from "@/utils/handleCookie";
import { useRouter } from "next/navigation";

const useAuth = () => {
  const router = useRouter();
  const { toast } = useToast();
  const profile = useProfileStore();
  const onLogout = async () => {
    try {
      const response = await logout();
      if (response) {
        // Clear profile data from store
        profile.clearProfile();
        profile.clearToken();
        profile.clearRefreshToken();
        onRemoveCookie();

        toast({
          title: "Success",
          type: "success",
          text: "Logout successful",
        });
        router.refresh();
      }
    } catch (error) {
      toast({
        title: "Error",
        type: "error",
        text: (error as string) || ERROR_MESSAGES_LOGOUT,
      });
      console.error("Logout failed:", error);
    }
  };

  return { onLogout };
};

export default useAuth;
